import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthHelper } from '../helpers/auth.helper';
import { Injectable } from '@angular/core';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private readonly authHelper: AuthHelper) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Skip adding Authorization header for S3 presigned URLs
    // S3 presigned URLs already contain authentication in the URL parameters
    if (this.isS3PresignedUrl(req.url)) {
      return next.handle(req);
    }

    const token = this.authHelper.getUserToken();

    if (token) {
      const headers = req.headers.set('Accept-Language', token.user.language || 'en').set('Authorization', `Bearer ${token.userToken}`);
      const authReq = req.clone({
        headers: headers,
      });

      return next.handle(authReq);
    }

    return next.handle(req);
  }

  /**
   * Skips the API Authorization header for direct browser uploads to presigned S3/CloudFront URLs.
   * AWS SigV4 query params (X-Amz-*) must be the only auth on that request; adding Bearer breaks the signature.
   * Host may be bucket.s3.region.amazonaws.com, CloudFront, or a custom S3 origin — do not require .amazonaws.com.
   */
  private isS3PresignedUrl(url: string): boolean {
    if (!url) {
      return false;
    }
    // Raw substring check: handles odd encodings and avoids URL parse failures
    if (
      url.includes('X-Amz-Algorithm=') ||
      url.includes('X-Amz-Signature=') ||
      url.includes('X-Amz-Credential=')
    ) {
      return true;
    }
    try {
      const u = new URL(url);
      return (
        u.searchParams.has('X-Amz-Algorithm') ||
        u.searchParams.has('X-Amz-Signature') ||
        u.searchParams.has('X-Amz-Credential')
      );
    } catch {
      return false;
    }
  }
}
